import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('bh-dialog-select-list')
export class BHDialogSelectList extends ChemistryLitElement {
  @state() readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  selectables = null;
  renderString = null;

  @state() value = null;

  override render() {
    return html`
      <x-flex vertical crossaxis-start ${css({ gap: '7px' })}>
        ${this.selectables?.map(sl => {
          return html`
            <x-button
              mode="text"
              class="hover-text-button"
              icon=${this.value.includes(sl) ? 'check_box' : 'check_box_outline_blank'}
              @click=${async () => {
                if (!this.value.includes(sl)) this.value = [...this.value, sl];
                else this.value = this.value.filter(it => it !== sl);
                this.dispatchEvent(new CustomEvent('onChange', { detail: this.value }));
              }}
            >
              ${this.renderString?.(sl)}
            </x-button>
          `;
        })}
      </x-flex>
    `;
  }
}
